function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export function initTeamModal() {
  var TeamModal = /*#__PURE__*/function () {
    function TeamModal() {
      _classCallCheck(this, TeamModal);
      this.modals = document.querySelectorAll('[data-member-modal]');
      if (!this.modals.length) return;
      this.init();
    }
    return _createClass(TeamModal, [{
      key: "init",
      value: function init() {
        var _this = this;
        document.addEventListener('click', function (e) {
          if (e.target.closest('.team-member__button')) {
            var button = e.target.closest('.team-member__button');
            var modalId = button.dataset.modalId;
            _this.openModal(modalId);
          }
        });
        document.addEventListener('click', function (e) {
          if (e.target.closest('[data-close-modal]')) {
            _this.closeActiveModal();
          }
        });
        this.modals.forEach(function (modal) {
          modal.addEventListener('click', function (e) {
            if (e.target === modal) {
              _this.closeActiveModal();
            }
          });
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            _this.closeActiveModal();
          }
        });
      }
    }, {
      key: "openModal",
      value: function openModal(modalId) {
        var modal = document.getElementById(modalId);
        if (!modal) return;
        modal.classList.add('active');
        document.body.classList.add('modal-open');
      }
    }, {
      key: "closeActiveModal",
      value: function closeActiveModal() {
        var activeModal = document.querySelector('[data-member-modal].active');
        if (!activeModal) return;
        activeModal.classList.remove('active');
        document.body.classList.remove('modal-open');
      }
    }]);
  }();
  new TeamModal();
}